import { useMemo } from 'react'
import { useAuth } from '@/context/AuthContext'

export function useUser() {
  // Use the centralized AuthContext instead of making separate API calls
  const { user, loading, refreshUser, token } = useAuth()

  const flags = useMemo(() => ({
    isAuthenticated: !!user,
    isLandlord: user?.role === 'landlord',
    isClient: user?.role === 'client',
    isAdmin: user?.role === 'admin'
  }), [user])
  
  return {
    user,
    loading,
    refreshUser,
    token,
    ...flags
  }
  
} 
